module.exports = __webpack_public_path__ + "efb8c48572a59d0e3d32c93b58e042dd.fbx";